module.exports = __webpack_public_path__ + "static/media/short-arrow-t.13d5750c.svg";